import { Clock3, MapPin, Package } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DashboardSection from "../components/DashboardSection";

function UpcomingDeliveries({ deliveries }) {
  const navigate = useNavigate();
  const rows = deliveries || [];
  return (
    <DashboardSection title="Today's Deliveries" description="Upcoming deliveries currently scheduled for today.">
      <div className="delivery-list">
        {rows.length ? rows.map((delivery) => (
          <article className="delivery-card" key={delivery.id}>
            <div className="delivery-card__time"><Clock3 size={17} /><strong>{delivery.time}</strong></div>
            <div className="delivery-card__details">
              <div><strong>{delivery.customer}</strong><span>#{delivery.orderNumber}</span></div>
              <p><MapPin size={15} />{delivery.address || "Delivery destination"}</p>
              <p><Package size={15} />{delivery.itemCount} items</p>
            </div>
            <button type="button" className="btn btn--secondary" onClick={() => navigate(delivery.path)}>View Order</button>
          </article>
        )) : <p className="admin-dashboard-empty">No deliveries scheduled today.</p>}
      </div>
    </DashboardSection>
  );
}

export default UpcomingDeliveries;
